import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '@shared/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
  ) {}

  public showConfirmDialogModal(
    confirmTxtId: string,
    messageTxtId: string,
  ): Observable<boolean> {
    const dialogData: ConfirmDialogData = {
      message: this.translateService.instant(messageTxtId),
      title: this.translateService.instant('common.confirmation.cancel_title'),
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
      panelClass: 'elearnio-mat-dialog-panel-class',
    });

    return dialogRef.afterClosed();
  }

  public showDeleteConfirmDialogModal(): Observable<boolean> {
    const dialogData: ConfirmDialogData = {
      message: this.translateService.instant(
        'common.confirmation.delete_message_question',
      ),
      title: this.translateService.instant('common.confirmation.delete_title'),
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
      panelClass: 'elearnio-mat-dialog-panel-class',
    });

    return dialogRef.afterClosed();
  }
}
